import colors from 'styles/theme/colors';

export default function ErrorWarningIcon({
  width = 14,
  height = 14,
  color = colors.red100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_984_7510)'>
        <path
          d='M5.99967 8.9165C6.13596 8.9165 6.2503 8.87042 6.34267 8.77825C6.43504 8.68609 6.48121 8.57184 6.48121 8.43555C6.48121 8.29925 6.43513 8.18492 6.34296 8.09255C6.25079 8.00017 6.13655 7.954 6.00025 7.954C5.86396 7.954 5.74962 8.00009 5.65725 8.09225C5.56488 8.18442 5.51871 8.29867 5.51871 8.43496C5.51871 8.57126 5.56479 8.68559 5.65696 8.77796C5.74913 8.87033 5.86337 8.9165 5.99967 8.9165ZM5.60621 6.68525H6.48121V2.99567H5.60621V6.68525ZM6.0039 11.8332C5.19948 11.8332 4.44357 11.68 3.73619 11.3738C3.02869 11.0675 2.41004 10.6495 1.88017 10.1196C1.35031 9.58976 0.932251 8.97075 0.626001 8.26259C0.319751 7.55442 0.166626 6.79775 0.166626 5.99255C0.166626 5.18734 0.319751 4.43067 0.626001 3.7225C0.932251 3.01434 1.35031 2.39775 1.88017 1.87275C2.41004 1.34775 3.02904 0.932129 3.73721 0.625879C4.44538 0.319629 5.20205 0.166504 6.00725 0.166504C6.81246 0.166504 7.56913 0.319629 8.27729 0.625879C8.98546 0.932129 9.60204 1.34775 10.127 1.87275C10.652 2.39775 11.0677 3.01513 11.3739 3.72484C11.6802 4.43455 11.8333 5.19157 11.8333 5.9959C11.8333 6.80032 11.6802 7.55623 11.3739 8.26361C11.0677 8.9711 10.652 9.58888 10.127 10.117C9.60204 10.645 8.98467 11.0631 8.27496 11.3712C7.56525 11.6792 6.80823 11.8332 6.0039 11.8332Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_984_7510'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
